import React from "react";

import connectToStores from "alt-utils/lib/connectToStores";
import TicketStore from "../../stores/TicketStore";
import TicketButton from "./ticket-button.jsx";
import TicketListItem from "./ticket-list/ticket-list-item.jsx";

class UniversalTicketButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buyingAdditionalTickets: false
    };
  }

  static get contextTypes() {
    return {
      tenant: React.PropTypes.object,
      appSettings: React.PropTypes.object,
      muiTheme: React.PropTypes.object
    };
  }

  static getStores() {
    return [TicketStore];
  }

  static getPropsFromStores() {
    return {};
  }

  getStyles() {
    return {
      button: {}
    };
  }

  render() {
    let styles = this.getStyles(),
      { buyingAdditionalTickets } = this.state,
      { event, appSettings } = this.props;

    let tickets = TicketStore.getTicketsByEventId(event.id),
      ticketCount =
        tickets.length || (event.person ? event.person.ticket_count : 0),
      hasTickets = ticketCount > 0,
      isVirtual = event.is_virtual,
      isLikelySoldOut =
        !event.tickets_available ||
        event.ticket_buckets
          .filter(b => b.public)
          .every(b => b.quantity_remaining <= 0),
      isExpiredVirtual =
        isVirtual &&
        hasTickets &&
        tickets.every(
          t => Date.now() > new Date(t.expires_at || t.unlocked_until)
        ),
      showBuyAdditionalDropdown = !isVirtual || isExpiredVirtual;

    let customActions = (this.props.customActions || []).map(a => {
      return {
        label: a.label,
        onClick: () => {
          this.props.onAction({
            target: {
              event_id: event.id
            },
            action: "custom_action",
            custom_action_name: a.name
          });
        }
      };
    });

    return (
      <div style={{ position: "relative" }}>
        {hasTickets && !buyingAdditionalTickets ? (
          <TicketListItem
            item={{
              event,
              tickets
            }}
            buttonOnly
            customActions={(!showBuyAdditionalDropdown
              ? []
              : [
                  {
                    label: isLikelySoldOut
                      ? "Buying additional tickets is not available: This event is sold out."
                      : "Buy additional tickets...",
                    disabled: isLikelySoldOut,
                    onClick: () => {
                      this.setState({ buyingAdditionalTickets: true });
                    }
                  }
                ]
            ).concat(customActions)}
            onWatchNow={
              this.props.consumePlayAction
                ? () => {
                    this.props.onAction({
                      target: {
                        event_id: event.id
                      },
                      action: "play"
                    });
                  }
                : undefined
            }
            sundanceMode={true}
            hideScanTickets={this.props.hideScanTickets}
            hideActions={this.props.hideActions}
          />
        ) : (
          <TicketButton
            event={this.props.event}
            inline={true}
            sundanceMode={true}
            appSettings={appSettings}
            hideActions={this.props.hideActions}
            buyingAdditionalTicketsFromMenuOnly={
              this.props.hideScanTickets && buyingAdditionalTickets
            }
            hideOrderButton={this.props.hideScanTickets}
            customActions={customActions.concat(
              buyingAdditionalTickets
                ? [
                    {
                      label: "Back to my tickets",
                      onClick: () => {
                        this.setState({ buyingAdditionalTickets: false });
                      }
                    }
                  ]
                : []
            )}
          />
        )}
      </div>
    );
  }
}

export default connectToStores(UniversalTicketButton);



// WEBPACK FOOTER //
// ./src/app/components/partials/universal-ticket-button.jsx